import React, { lazy, Suspense } from "react";
import { useInView } from "react-intersection-observer";

const SuscribeComponent = lazy(() => import("../../components/home/suscribe.component"));

const LazySuscribe = () => {
  const { ref, inView } = useInView({
    triggerOnce: true,
    threshold: 0.1,
  });

console.log(inView);

  return (
    <div ref={ref}>
      {inView ? (
        <Suspense fallback={<div>Cargando Portafolio...</div>}>
          <SuscribeComponent />
        </Suspense>
      ) : (
        <div>Cargando Suscribe...</div>
      )}
    </div>
  );
};

export default LazySuscribe;
